const MS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_DAY = 86400;

/** Human-readable refresh TTL for the controls dev panel (ms → d/h/m or raw ms when under 1s). */
export const formatTtlMs = (totalMs: number): string => {
  if (totalMs < MS_PER_SECOND) {
    return `${totalMs} ms`;
  }

  const totalSec = Math.round(totalMs / MS_PER_SECOND);
  const days = Math.floor(totalSec / SECONDS_PER_DAY);
  const hours = Math.floor((totalSec % SECONDS_PER_DAY) / SECONDS_PER_HOUR);
  const minutes = Math.floor(
    (totalSec % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE,
  );
  const parts: string[] = [];

  if (days > 0) {
    parts.push(`${days}d`);
  }

  if (hours > 0) {
    parts.push(`${hours}h`);
  }

  if (minutes > 0 || parts.length === 0) {
    parts.push(`${minutes}m`);
  }

  return parts.join(" ");
};
